import React, { useEffect, useState, useRef } from "react";
import { Button, message } from "antd";
import api from "utils/api";
import { CONSTANTS } from "utils/constant";
import { ExportIcon } from "Common/ReactIcons";

const ExportButton = (props) => {
  const [excelLink, setExcelLink] = useState("");
  const [excelGenerated, setExcelGenerated] = useState(false);
  const exportTimerRef = useRef(null);

  useEffect(() => {
    exportCheckStatus();
    // Cleanup interval on component unmount
    return () => clearInterval(exportTimerRef.current);
  }, []);

  const excelReportTrigger = () => {
    api
      .trigger_export_webhook({ org_id: props?.orgId || "" })
      .then((response) => {
        if (response.data.status === 200) {
          message.info(response?.data?.message, ErrorDuration);
          setExcelGenerated(true);
          startPolling();
        } else {
          message.error(response.data.message, ErrorDuration);
        }
      })
      .catch((error) => {
        // Handle error
        message.error(
          "An error occurred while triggering the export.",
          ErrorDuration
        );
      });
  };

  const startPolling = () => {
    exportTimerRef.current = setInterval(() => {
      exportCheckStatus();
    }, 60000); // Check every 60 seconds
  };

  const exportCheckStatus = () => {
    api
      .excel_report_status({ org_id: props?.orgId || "" })
      .then((response) => {
        if (response.data.status === 200) {
          setExcelLink(response.data?.data?.record_link || "");
          setExcelGenerated(response.data?.data?.is_export || false);

          if (!exportTimerRef.current && response.data?.data?.is_export) {
            startPolling();
          }

          if (!response.data?.data?.is_export) {
            clearInterval(exportTimerRef.current);
            exportTimerRef.current = null;
          }
        } else {
          message.error(response.data.message, ErrorDuration);
        }
      })
      .catch((error) => {
        // Handle error
        console.log(error);
        message.error(
          "An error occurred while checking the export status.",
          ErrorDuration
        );
      });
  };

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "auto auto",
        justifyContent: excelLink ? "space-between" : "flex-end",
        marginLeft: "3%",
      }}
      className="case-summary-export-container"
    >
      {excelLink && (
        <a
          style={{ margin: "auto" }}
          href={excelLink}
          rel="noopener noreferrer"
          target="_blank"
        >
          {/* {CONSTANTS.VIEW_REPORT} */}
          Download Report
        </a>
      )}
      <Button
        type="link"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "5px",
        }}
        onClick={excelReportTrigger}
        loading={excelGenerated}
      >
        <ExportIcon />
        <div>
          {/* {CONSTANTS.EXPORT} */}
          Generate Report
        </div>
      </Button>
    </div>
  );
};

export default ExportButton;
